export function getLocaleCandidates(i18n) {
  const locales = [];
  if (i18n?.locale) {
    locales.push(i18n.locale);
  }

  const fallback = i18n?.fallbackLocale;
  if (Array.isArray(fallback)) {
    locales.push(...fallback);
  } else if (fallback) {
    locales.push(fallback);
  }

  if (!locales.includes('en')) {
    locales.push('en');
  }

  return Array.from(new Set(locales));
}

export function getLocaleBlock(i18n, path, defaultValue = undefined) {
  if (!i18n || !path) {
    return defaultValue;
  }

  const keys = Array.isArray(path) ? path : path.split('.');
  const locales = getLocaleCandidates(i18n);

  for (const locale of locales) {
    const root = i18n.messages?.[locale];
    if (!root) {
      continue;
    }

    const value = keys.reduce((acc, key) => {
      if (acc && Object.prototype.hasOwnProperty.call(acc, key)) {
        return acc[key];
      }
      return undefined;
    }, root);

    if (value !== undefined) {
      return value;
    }
  }

  return defaultValue;
}
